import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-m-couponmanagement",
  "use": "icon-soc-m-couponmanagement-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-m-couponmanagement\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\" fill=\"currentColor\">\r\n<circle cx=\"780\" cy=\"280\" r=\"28\" /><path d=\"M192 352h640v320H192z\" /><circle cx=\"192\" cy=\"512\" r=\"48\" fill=\"#fff\" /><circle cx=\"832\" cy=\"512\" r=\"48\" fill=\"#fff\" /><path d=\"M448 416v192M576 416v192\" stroke=\"#fff\" stroke-width=\"32\" fill=\"none\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-m-couponmanagement.svg
// module id = w0Mj
// module chunks = 477